import { IconButton } from '@nike/eds'
import { ConfirmationModal } from 'components/confirmation-modal'

import { type ActionConfig, type ConfirmationConfig } from './TableView'

interface TableActionsProps {
  rowData: any
  rowId: string
  actions?: ActionConfig[]
  actionsWithConfirmation?: ConfirmationConfig[]
}

/**
 * TableActions component handles rendering action buttons in the table
 * Used by TableView to render both regular actions and confirmation actions
 */
export const TableActions = ({
  rowData,
  rowId,
  actions,
  actionsWithConfirmation
}: TableActionsProps) => {
  return (
    <div className='flex gap-2'>
      {actions?.map(action => {
        const shouldShowAction = action.show ? action.show(rowData) : true
        return shouldShowAction && (
          <IconButton
            key={`${action.label}-${String(rowId)}`}
            label={action.label}
            variant={'secondary'}
            size='small'
            icon={action.icon}
            disabled={action.disabled ? action.disabled(rowData) : false}
            onClick={() => {
              action.onClick(rowData)
            }}
            title={action.hoverText}
            className={'z-0'}
          />
        )
      })}
      {actionsWithConfirmation?.map(action => {
        const shouldShowAction = action.show ? action.show(rowData) : true
        return shouldShowAction && (
          <ConfirmationModal
            key={`${action.title}-${String(rowId)}`}
            onTrigger={() => {
              action.onClick(rowData)
            }}
            title={action.title}
            message={action.message}
            icon={action.icon}
            iconSize='m'
            iconClass="confirm-icon-button"
            confirmText={action.confirmText}
          />
        )
      })}
    </div>
  )
}
